import { DataTableV2 } from "@platform/design-system";
import { useMemo } from "react";
import { useFeatureIsOn } from "@growthbook/growthbook-react";
import { RFP_COPY } from "@platform/feature-flags";
import { useSignedInUser } from "@platform/user/client";

import { headers, headersAdmin } from "../pages/RFPs/utils";
import { RfpsTableOptions } from "../types/rfpGridContext";

import { DetailRow } from "./RfpsTable/DetailRow";

const ACTIONS_COL_ID = "actions";

type RFPsTableProps = {
  isBrokerPartner: boolean;
  options?: RfpsTableOptions;
};

export const RFPsTable: React.FC<RFPsTableProps> = ({
  isBrokerPartner,
  options = {},
}) => {
  const { isAnalyst, isAdminOrConsultant } = useSignedInUser();
  const rfpCopyEnabled = useFeatureIsOn(RFP_COPY);

  const showActions = rfpCopyEnabled && isAdminOrConsultant;

  const columns = useMemo(() => {
    const base =
      (isAdminOrConsultant || isAnalyst) && !isBrokerPartner
        ? headersAdmin
        : headers;

    return base.map((col) =>
      col.colId === ACTIONS_COL_ID
        ? {
            ...col,
            width: showActions ? 70 : 0,
            minWidth: 0,
            maxWidth: showActions ? 70 : 0,
          }
        : col,
    );
  }, [isAdminOrConsultant, isAnalyst, isBrokerPartner, showActions]);

  return (
    <>
      <DataTableV2
        columnDefs={columns}
        overlayNoRowsTemplate="No RFPs found"
        masterDetail={true}
        detailRowAutoHeight={true}
        detailCellRenderer={DetailRow}
        gridOptions={{ ...options }}
      />

      <style>{`
        .rfp-status-cell .ag-cell-wrapper {
          width: 100%;
        }
      `}</style>
    </>
  );
};
